import React from 'react';
import { useTempState } from '@starflow/app/store';
import { CheckpointsWindow } from './checkpoint';
import { LorasWindow } from './lora';
import CheckpointModels from './checkpointModels';
import LoraModels from './loraModels';
import PresetModels from './presetModels';
import WorkflowModels from './workflowModels';
import { config } from '@shakkerai/config';

export const ModelWindows = React.memo(() => {
  const exclusiveWindow = useTempState('exclusiveWindow');
  const isOverseas = config.env === 'aws';

  if (exclusiveWindow === 'model-loras') {
    return isOverseas ? <LorasWindow /> : <LoraModels />;
  }

  if (exclusiveWindow === 'model-checkpoints') {
    return isOverseas ? <CheckpointsWindow /> : <CheckpointModels />;
  }

  if (exclusiveWindow === 'model-workflows') {
    return <WorkflowModels />;
  }

  if (exclusiveWindow === 'preset-flow') {
    return <PresetModels />;
  }

  return null;
});
